import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accolades-list-simple.component.scss';
var AccoladesListSimple = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesListSimple, _super);
    function AccoladesListSimple(element) {
        return _super.call(this, element) || this;
    }
    AccoladesListSimple.prototype.init = function () {
    };
    AccoladesListSimple.prototype.bindEvents = function () {
    };
    return AccoladesListSimple;
}(Base));
export { AccoladesListSimple };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-simple/accolades-list-simple.component.ts
// module id = 74
// module chunks = 0